import PropTypes from 'prop-types'

import Icon from '../../../Icons'

const ModalHeader = ({
  // NOTE: `closeable` defaults `undefined` intentionally to simply control when only `onClose` is passed
  closeable = undefined,
  onClose = undefined,
  title,
  icon = null,
  style = {},
  className,
}) => {
  const isCloseable = closeable === undefined ? !!onClose : closeable

  return (
    <div className="modal-container-header">
      <div className={`${className} modal-container-header--title`} style={style}>
        {icon || null}
        {title && <div>{title}</div>}
      </div>
      {isCloseable && onClose && (
        <div onClick={onClose} className="navi-button">
          <Icon icon="cross" viewBox="0 0 20 20" />
        </div>
      )}
    </div>
  )
}

ModalHeader.propTypes = {
  closeable: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  icon: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
}

export default ModalHeader
